import {
  Directive,
  HostListener,
  Output,
  EventEmitter,
  ElementRef,
  inject,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[dragDrop]',
  standalone: true,
})
export class DragDropDirective {
  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Output() fileDropped = new EventEmitter<any>();

  @HostListener('dragleave', ['$event']) onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.renderer.removeClass(this.elementRef.nativeElement, 'dragging-over');
  }

  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {
    event.preventDefault();
    this.renderer.addClass(this.elementRef.nativeElement, 'dragging-over');
  }

  @HostListener('drop', ['$event']) onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.renderer.removeClass(this.elementRef.nativeElement, 'dragging-over');

    const files = event.dataTransfer?.files;
    if (files?.length) {
      this.fileDropped.emit(event);
    }
  }
}
